import { getPrepStationId } from './chunk-GHIPCFZD.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var getGenericError = ({
  key,
  message,
  id,
  section
}) => ({
  [key]: {
    id: "genericError" /* GENERIC_ERROR */,
    data: {
      message
    },
    kind: {
      id,
      data: {
        message
      },
      type: "genericError" /* GENERIC_ERROR */,
      section
    }
  }
});
var getModifierTagError = (key, field) => {
  const objectKey = getPrepStationId(key, field);
  return getGenericError({
    key: objectKey,
    id: "prepStations",
    message: i18n_config_default.t("settingsModule.prepStationsSettings.errors.name"),
    section: "all" /* ALL */
  });
};
var prepStationsSchema = yup.object().shape({
  prepStations: yup.lazy(
    (obj) => yup.object(
      mapValues(
        obj,
        (_, key) => yup.object({
          name: yup.string().trim().required(JSON.stringify(getModifierTagError(key, "name"))),
          posName: yup.string().trim().required(JSON.stringify(getModifierTagError(key, "posName")))
        })
      )
    )
  )
});

export { prepStationsSchema };
